export default "__VITE_ASSET__BuzbnRAH__"